import { Injectable } from '@angular/core';
import { RepositoryService } from '../../../helpers/crud/repository.service';
import { WancomHttpService } from '../../../services/wancom-http/wancom-http.service';
import { WaitingService } from '../../layout/waiting/waiting.service';
import { environment } from '../../../../environments/environment';
import { CartInput, CartInfos } from '../model/store.model';

@Injectable({
    providedIn: 'root',
})
export class OrderService extends RepositoryService<any> {
    constructor(http: WancomHttpService, waiting$: WaitingService) {
        super(http, waiting$, 'order');
    }

    /**
     *
     * Récupère la panier de l'utilisateur pour lui afficher lorsqu'il n'est pas connecté
     *
     * @param faceIds Ids des faces sélectionnées
     * @param startDate Date de début de la campagne
     * @param endDate Date de fin de la campagne
     * @param durationSpot Durée du spot (par défaut 10s)
     * @returns Le panier pour un utilisateur pas encore connecté
     */
    getCart(
        faceIds: number[],
        startDate,
        endDate,
        campaignName: string,
        durationSpot: number = 10,
        spotOrdered,
        templateOrdered,
    ) {
        const cartInput: CartInput = {
            fAs: faceIds,
            sd: startDate,
            ed: endDate,
            ds: durationSpot,
            cn: campaignName,
            so: spotOrdered
        };
        return this.http.post<CartInfos>(
            `${this.url}/Cart`,
            cartInput,
            environment.apiBaseStore
        );
    }

    getCartLight(
        faceIds: number[],
        startDate,
        endDate,
        campaignName: string,
        durationSpot: number = 10,
        spotOrdered,
        templateOrdered,
    ) {
        const cartInput: CartInput = {
            fAs: faceIds,
            sd: startDate,
            ed: endDate,
            ds: durationSpot,
            cn: campaignName,
            so: spotOrdered
        };
        return this.http.post<{ ht: number }>(
            `${this.url}/CartLight`,
            cartInput,
            environment.apiBaseStore
        );
    }

    /**
     *
     * sauvegarde en base le panier de l'utilisateur pour procéder au paiement
     *
     * @param faceIds Ids des faces sélectionnées
     * @param startDate Date de début de la campagne
     * @param endDate Date de fin de la campagne
     * @param durationSpot Durée du spot (par défaut 10s)
     * @returns Le panier pour un utilisateur connecté
     */
    createCart(
        faceIds: number[],
        startDate,
        endDate,
        campaignName: string,
        durationSpot: number = 10,
        spotOrdered,
        templateOrdered,
    ) {
        const createCartInput: CartInput = {
            fAs: faceIds,
            sd: startDate,
            ed: endDate,
            ds: 10,
            cn: campaignName,
            so: spotOrdered
        };
        return this.http.post<number>(
            `${this.url}/CreateCart`,
            createCartInput,
            environment.apiBaseStore
        );
    }

    /**
     *
     * @param orderId Numéro de commande à récupérer
     * @returns Le détail de la commande dans un objet `CartInfos`
     */
    getRecapOrder(orderId: number) {
        return this.http.get<CartInfos>(
            `${this.url}/getRecapOrder/${orderId}`,
            environment.apiBaseStore
        );
    }
}
